import { DashboardModule, Form } from '@domain-group/suit-theme'

import InfoToolTip from '@components/InfoToolTip'

import type { UseFormPayload } from '@domain-group/react-hooks'

interface AgentInformationProps {
  agentFormPayload: UseFormPayload,
}

const AgentInformation = (props: AgentInformationProps) => {
  const { agentFormPayload } = props
  const {
    entityState: {
      agent_title,
      business_name,
      business_number,
      license_number,
      other_enquiry_email,
      profile,
    },
    errors,
    handlers,
  } = agentFormPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <InfoToolTip>
          Your agent title and description may be used across marketing products and proposals.
        </InfoToolTip>
      )}
      title="Agent Information"
    >
      <Form padding="large">
        <Form.Field label="Agent Title">
          <input
            name="agent_title"
            value={agent_title}
            type="text"
            {...handlers}
          />
        </Form.Field>

        <Form.Field label="Bio/Description" marginTop="large">
          {/*
           // @ts-expect-error TS2322 */}
          <textarea name="profile" value={profile} {...handlers} style={{ height: 100, resize: 'vertical' }} />
        </Form.Field>

        <Form.Field label="Business Name" marginTop="large">
          <input
            name="business_name"
            value={business_name}
            type="text"
            {...handlers}
          />
        </Form.Field>

        <Form.Row marginTop="large">
          <Form.Field label="ABN or NZBN">
            <input
              name="business_number"
              value={business_number}
              type="text"
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="License Number" marginTop={['large', 0]}>
            <input
              name="license_number"
              type="text"
              value={license_number}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Field errorMessage={errors.other_enquiry_email} label="Other Enquiry Email" marginTop="large">
          <input
            name="other_enquiry_email"
            type="email"
            value={other_enquiry_email}
            {...handlers}
          />
        </Form.Field>
      </Form>
    </DashboardModule>
  )
}

export default AgentInformation
